import axios from './providers/axios';
import {convertBooleanValuesToNumbers} from "@/utils/utils";
const gamificationService = {
    getLeaderboards(page, filters = []) {
        let queryParams = `limit=20&page=${page}`;

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                if (Array.isArray(filter.value)) {
                    filter.value.forEach((item, index) => {
                        Object.keys(item).forEach(key => {
                            queryParams += `&${filter.key}[${index}][${key}]=${item[key]}`;
                        });
                    });
                } else {
                    queryParams += `&${filter.key}=${filter.value}`;
                }
            });
        }

        return axios.get(`/v1/admin/leaderboard/store?${queryParams}`);
    },
    getGamificationTasks() {
        return axios.get('/v1/admin/gamificationTasks/store');
    },
    updateGamificationTask(data) {
        return axios.post('/v1/admin/gamificationTasks/update',data)
    },
    deleteCustomGamificationTask(id) {
        return axios.delete(`/v1/admin/gamificationTasks/delete/${id}`);
    },
    customizeGamificationTask(data) {
        return axios.post('/v1/admin/gamificationTasks/customizeTask', data);
    },
    resetLeaderboard(){
        return axios.post('/v1/admin/leaderboard/reset');
    }



}

export default gamificationService;
